export default {
  backButton: 'All teams',
};
